import React, { useState } from 'react';
import s from './AccordionWithChild.scss';

const AccordionWithChild = ({ children }) => {
  const [activeIndex, setActiveIndex] = useState(1);

  const toggleAccordion = index => {
    setActiveIndex(activeIndex === index + 1 ? null : index + 1);
  };

  return (
    <div className="accordion">
      {React.Children.map(children, (child, index) =>
        React.cloneElement(child, {
          isActive: index + 1 === activeIndex,
          toggleAccordion: () => toggleAccordion(index),
        }),
      )}
    </div>
  );
};

const AccordionItem = ({ isActive, toggleAccordion, children, title }) => (
  <div className="accordion-item">
    <div
      className={`accordion-title ${isActive ? 'active' : ''}`}
      onClick={toggleAccordion}
    >
      {title} <i className="arrow" />
    </div>
    {isActive && <div className="accordion-content">{children}</div>}
  </div>
);

export { AccordionWithChild, AccordionItem };
